import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { LangContext } from "../LangContext.jsx"; 
import { identityLabel } from '../identityLabel.mjs';
class ProviderInformationCard extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            documents:[],
            provider: {
                name: "",
                provider:{
                    name:''
                },
                user:{
                    email:''
                },
                dossier:{
                    title:'',
                    target:{
                        name:'s'
                    },
                    type:{
                        name:'s'
                    }
                },
                email:"",
                identity:"",
                rfc:"",
                internal_id:""
            }
        }; 
    }
    getProvider = ()=>{
        axios.get('/api/provider/'+this.props.person_provider_id).then(res=>{
            this.setState({provider:res.data})
        })
    }
    componentDidMount() {
        this.getProvider()
    }
    
    render() {
        const { lang } = this.context; 
        return ( <div className="d-flex align-items-center col-5">
        <div className="symbol symbol-40 mr-5">
            <div className="symbol-label bg-primary text-white font-weight-bolder">
                {this.state.provider?.provider.name[0] } 
            </div>
        </div>
        <h5 className="text-dark font-weight-bold my-1 mr-5">
            {this.state.provider?.provider.fiscal_name } &nbsp;<span className="text-muted font-weight-bold font-size-sm">{ this.state.provider?.user.email  }</span>
            <br></br>
            <div className="mt-2 font-size-sm">
                <span className="text-muted font-weight-bold">{lang.get('messages.expediente_invitado')}:</span>
                <span className="text-success mr-10">{ this.state.provider?.dossier.title }</span>
            </div>
            <div className="mt-2 font-size-sm">
            <span className="text-muted font-weight-bold"> {identityLabel(this.state.provider?.provider.country_id, this.state.provider?.provider.identity || 'RFC')}: </span>
            <span className="text-success">{ this.state.provider?.provider.rfc}</span>
            <span className="text-muted">
                    &nbsp; 
                    | &nbsp; 
                    {( this.state.provider.internal_company_identifier != null) && 
                    <>
                        No. {lang.get('messages.interno')}: {  this.state.provider.internal_company_identifier.internal_id } {' | '}
                    </>
                    } 
                    {lang.get('messages.'+this.state.provider.dossier.target.name?.toLowerCase())}
                    &nbsp;
                    ( {lang.get('messages.'+this.state.provider.dossier.type.title?.toLowerCase())} )
                </span>
            </div>
        </h5> 
    </div>);
    }
}

export default ProviderInformationCard;

if (document.getElementById('ProviderInformationCard')) {
    ReactDOM.render(<ProviderInformationCard />, document.getElementById('ProviderInformationCard'));
}
